/* oddjuice – Size Guide Modal (sticky + correct position) */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var sizeGuideUrl =
    (window.ojSizeGuideUrl && window.ojSizeGuideUrl.trim()) ||
    '/pages/size-guide';

  // ---------- Modal einmalig einfügen ----------
  function ensureModal() {
    if (document.getElementById('oj-sizeguide-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'oj-sizeguide-modal';
    modal.className = 'oj-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'oj-sizeguide-title');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');
    modal.innerHTML = `
      <div class="oj-modal__backdrop" data-oj-close></div>
      <div class="oj-modal__dialog" role="document">
        <header class="oj-modal__header">
          <h2 id="oj-sizeguide-title" class="oj-modal__title">Size Guide</h2>
          <button type="button" class="oj-modal__close" aria-label="Close" data-oj-close>&times;</button>
        </header>
        <div class="oj-modal__body" id="oj-sizeguide-body">
          <div style="color:#777;font-size:.95rem;">Loading…</div>
        </div>
      </div>`;
    document.body.appendChild(modal);

    // Inhalt laden
    fetch(sizeGuideUrl, { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var content =
          tmp.querySelector('.shopify-policy__body .rte') ||
          tmp.querySelector('.page-width .rte') ||
          tmp.querySelector('main .rte') ||
          tmp.querySelector('.rte');
        var pageH1 =
          tmp.querySelector('.shopify-policy__title, .page-title, main h1, h1');
        if (pageH1)
          document.getElementById('oj-sizeguide-title').textContent =
            pageH1.textContent.trim();
        document.getElementById('oj-sizeguide-body').innerHTML =
          content ? content.innerHTML : '<p>Size guide not found.</p>';
      })
      .catch(() => {
        document.getElementById('oj-sizeguide-body').innerHTML =
          '<p>Could not load size guide.</p>';
      });
  }

// ---------- Button stabil NACH dem Variant Picker platzieren ----------
function insertButton() {
  // Ganzer Produktinfo-Bereich
  var info = document.querySelector('[id^="ProductInfo-"]');
  if (!info) return;

  // Variant Picker (Größenauswahl)
  var picker = info.querySelector('.product-form__input--pill');
  if (!picker) return;

  // Bereits vorhanden? -> Verhindert doppelte Buttons
  if (info.querySelector('#oj-sizeguide-slot')) return;

  // Button-Slot erzeugen
  var slot = document.createElement('div');
  slot.id = 'oj-sizeguide-slot';
  slot.className = 'oj-sizeguide-link';
  slot.style.margin = '0.4rem 0 0.8rem 0';
  slot.innerHTML =
    '<button type="button" class="oj-sizeguide-btn" data-oj-open-sizeguide aria-haspopup="dialog" aria-controls="oj-sizeguide-modal">Size Guide</button>';

  // Direkt nach dem Variant Picker einfügen (aber außerhalb des Formulars)
  picker.parentElement.insertAdjacentElement('afterend', slot);

  // Event Listener für Klick aktivieren
  wireUp();
}



  // ---------- Öffnen / Schließen ----------
  function wireUp() {
    var modal = document.getElementById('oj-sizeguide-modal');
    var openBtn = document.querySelector('[data-oj-open-sizeguide]');
    if (!modal || !openBtn) return;

    openBtn.addEventListener('click', () => {
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    });

    modal.querySelectorAll('[data-oj-close]').forEach(el => {
      el.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', e => {
      if (e.target.classList.contains('oj-modal__backdrop')) closeModal();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false')
        closeModal();
    });

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }
  }

  // ---------- Beobachte Variant-Wechsel (Dawn re-render) ----------
  function observeReRenders() {
    var productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!productInfo) return;
    var obs = new MutationObserver(() => {
      if (!document.querySelector('.oj-sizeguide-link')) {
        insertButton();
      }
    });
    obs.observe(productInfo, { childList: true, subtree: true });
  }

  function init() {
    ensureModal();
    insertButton();
    observeReRenders();
  }

  document.addEventListener('DOMContentLoaded', init);
  setTimeout(init, 400);
})();
